import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "160",
  height: "160",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFFFFE",
      d: "M32.178 58.122h20.624a2.51 2.51 0 0 0 2.508-2.484V35.014a2.508 2.508 0 0 0-4.289-1.758L30.397 53.88a2.507 2.507 0 0 0 .395 3.843c.41.274.893.398 1.386.4m18.14-4.992H38.2l12.117-12.093z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFFFFE",
      d: "M102.042 32.506h-49.24c-.703 0-1.312.282-1.781.75L30.397 53.88a2.52 2.52 0 0 0-.727 1.758v85.566h72.372V32.506m-48.209 4.992h43.24v98.714H34.686V56.669l19.17-19.17z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFFFFE",
      d: "M60.817 33.701a2.508 2.508 0 1 1-5.015 0v-13.71h64.052V22.5L120 128.712H99.745a2.508 2.508 0 1 1 0-5.015h15.117v-98.69H60.794z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFFFFE",
      d: "M89.996 55.005a2.508 2.508 0 0 1 0 4.992H67.66a2.508 2.508 0 0 1 0-4.992zm0 12.492a2.508 2.508 0 0 1 0 4.992H42.514a2.508 2.508 0 0 1 0-4.992zm0 13.335a2.508 2.508 0 0 1 0 4.992H42.514a2.508 2.508 0 0 1 0-4.992zm0 13.335a2.508 2.508 0 0 1 0 4.992H42.514a2.508 2.508 0 0 1 0-4.992zm0 13.336a2.508 2.508 0 0 1 0 4.992H42.514a2.506 2.506 0 0 1 0-4.992zm0 12.491a2.505 2.505 0 0 1 2.265 2.496 2.51 2.51 0 0 1-2.265 2.496H42.514a2.508 2.508 0 0 1 0-4.992z"
    }, null, -1)
  ])))
}
export default { render: render }